import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { BrandProductPreviewResource } from '@/entities/Brand/api';
import { LinkHelper } from '@/Services';

import S from './PreviewProduct.module.scss';

interface PreviewProductProps {
    previewProduct: BrandProductPreviewResource;
}

export const PreviewProduct: FC<PreviewProductProps> = ({ previewProduct }) => {
    return (
        <Link to={LinkHelper.dataProductId(previewProduct.id)} className={S.root} target={'_blank'}>
            <p>{previewProduct.name}</p>
        </Link>
    );
};
